<template>
  <ul class="my-bread-crumb x-grey-text">
    <template v-for="(item, index) in data">
      <template v-if="item.url">
        <li v-if="item.url === '-1'" class="x-flex-align" :key="index" @click="$router.back(-1)">
          <i v-if="item.icon" :class="['iconfont x-blue-text', item.icon]"></i>
          <i class="text click">{{ item.name }}</i>
        </li>
        <router-link v-else class="x-flex-align" :to="item.url" tag="li" :key="index">
          <i v-if="item.icon" :class="['iconfont x-blue-text', item.icon]"></i>
          <i class="text click">{{ item.name }}</i>
        </router-link>
      </template>
      <li v-else class="x-flex-align" :key="index">
        <i v-if="item.icon" :class="['iconfont x-blue-text', item.icon]"></i>
        <i class="text">{{ item.name }}</i>
      </li>
    </template>
  </ul>
</template>
<script>
export default {
  name: 'MyBreadcrumb',
  props: {
    data: {
      // 面包屑数据
      type: Array,
      default: () => {
        return [];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.my-bread-crumb {
  box-sizing: border-box;
  display: flex;
  align-items: flex-end;
  height: 60px;
  padding-bottom: 18px;

  > li:first-child {
    .text {
      color: #1d2944;
      font-size: 18px;
      font-weight: 600;
    }

    > .iconfont {
      margin-right: 8px;
      font-size: 18px;
    }
  }

  > li {
    margin-right: 8px;

    .click {
      cursor: pointer;

      &:hover {
        color: #0087ff;
      }
    }
  }

  .el-breadcrumb__inner {
    font-size: 14px;
    color: #bfc5d2;
    font-weight: normal;
  }

  // 斜线
  .el-breadcrumb__separator {
    font-weight: normal;
  }

  // 最后一个面包屑
  .el-breadcrumb__item:last-child {
    .el-breadcrumb__inner {
      color: #1d2944 !important;
    }
  }
}
</style>
